export default __webpack_public_path__ + "static/media/malayali.1fedcbb0.svg";